import { Dispatch, SetStateAction } from 'react';
import { JsonStorage } from '@shared/util/storage/JsonStorage';
import { useLocalStorage } from '@shared/util/storage/useLocalStorage';
import { FlagName, Flags } from './flags';

type FeatureFlagValue<T extends FlagName> = Flags[T] | null;
type FeatureFlagSetter<T extends FlagName> = Dispatch<SetStateAction<FeatureFlagValue<T>>>;

export function useLocalFeatureFlag<T extends FlagName>(
  flagName: T,
): [FeatureFlagValue<T>, FeatureFlagSetter<T>, VoidFunction] {
  const key = `feature-flag:${flagName}`;
  const [localFlag, setLocalFlag, , removeLocalFlag] = useLocalStorage<FeatureFlagValue<T>>(
    key,
    null,
  );

  return [localFlag, setLocalFlag, removeLocalFlag];
}

if (import.meta.env.DEV) {
  function setLocalFeatureFlag<T extends FlagName>(name: T, value: Flags[T]) {
    const key = `feature-flag:${name}`;
    JsonStorage.set(key, value);
  }

  // in dev console, setLocalFlag('layout-toggle-buttons', true | false | null)
  (window as any).setLocalFlag = setLocalFeatureFlag;
}
